import { EMPTY_STRING, NO_VALUE_RESPONSE, TWO } from '@constants';
import { Nullable } from '@customTypes';
import { round } from 'lodash';

export const nullableNumberToString = (value: Nullable<number>): string => {
  if (value === null || value === NO_VALUE_RESPONSE) {
    return EMPTY_STRING;
  } else {
    return round(value, TWO).toString();
  }
};
